import React from 'react';
import './CompanyList.css';

const CompanyList = () => {
  const companies = [
    { name: 'CyberDesk GmbH', logo: '🛡️' },
    { name: 'Normalyze Inc.', logo: '🔐' },
    { name: 'JPMorgan Chase & Co.', logo: '🏦' },
    { name: 'Oracle India', logo: '☁️' },
    { name: 'Woovly India', logo: '📱' },
    { name: 'HKUST', logo: '🎓' },
    { name: 'LeewayHertz', logo: '💊' },
    { name: 'GirlScript Foundation', logo: '👩‍💻' },
    { name: 'OpenGenus Foundation', logo: '🧠' },
  ];
  

  // Duplicate the array for seamless infinite scroll
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <div className="mt-6">
      <div className="text-center mb-4">
        <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">
          Engineering and Research Experience
        </h4>
        <p className="text-xs text-gray-600 dark:text-gray-400">
          Companies I've worked with
        </p>
      </div>
      
      {/* Compact scrolling container */}
      <div className="relative overflow-hidden">
        {/* Gradient fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-gray-50 to-transparent dark:from-gray-900 z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-gray-50 to-transparent dark:from-gray-900 z-10"></div>
        
        {/* Scrolling content */}
        <div className="flex space-x-4 company-scroll">
          {duplicatedCompanies.map((company, index) => (
            <div
              key={`${company.name}-${index}`}
              className="flex-shrink-0 flex items-center space-x-2 px-3 py-2 bg-white dark:bg-gray-800 rounded-md shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-200 dark:border-gray-700"
            >
              <span className="text-lg">{company.logo}</span>
              <span className="text-sm font-medium text-gray-900 dark:text-gray-100 whitespace-nowrap">
                {company.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyList;
